import React, {useCallback, useEffect, useState} from 'react';
import {generateMarkers} from "../../helpers/helpers";
import {useObservationImages} from "../../helpers/useObservationImages";
import MapView from "./map-view";
import {MapMode} from "./constants";
import type {MapExplorerProps, MapModeType} from "./types";

export default function MapExplorer({
    observations,
    year,
    month,
    observationsByLocation,
    onStartBigYear,
    onShowTimePeriodSelector,
    mapMode,
    activeSpecies = 0,
    speciesImages,
    getSpeciesImages,
    lookupByTaxonomicOrder,
    familyByTaxonomicOrder,
    parentTaxonomicOrderByTaxonomicOrder
}: MapExplorerProps) {
    const [markers, setMarkers] = useState<any>();
    const [activeLocation, setActiveLocation] = useState<any>();
    const getImageTaxonomicOrder = useCallback((taxonomicOrder: number) => {
        return parentTaxonomicOrderByTaxonomicOrder.get(taxonomicOrder) ?? taxonomicOrder;
    }, [parentTaxonomicOrderByTaxonomicOrder]);
    const { setObservationImages, setObservationImagesForMarkers } = useObservationImages(
        speciesImages,
        lookupByTaxonomicOrder,
        getImageTaxonomicOrder
    );
    const resolvedMapMode = Object.values(MapMode).includes(mapMode as MapModeType)
        ? mapMode as MapModeType
        : MapMode.Year;

    useEffect(() => {
        const markers = generateMarkers(observations);

        getSpeciesImages(markers);
        setObservationImagesForMarkers(markers);
        setObservationImages(observations);
        setMarkers(markers);

    }, [getSpeciesImages, observations, setObservationImages, setObservationImagesForMarkers]);

    useEffect(() => {
        if (markers?.features?.length) {
            setObservationImagesForMarkers(markers);
        }

    }, [markers, setObservationImagesForMarkers, speciesImages]);

    if (!markers?.features?.length) {
        return null;
    }

    return (
        <>
            <MapView
                markers={markers}
                year={year}
                month={month}
                mode={resolvedMapMode}
                showPlayControls={resolvedMapMode === MapMode.Year}
                activeSpecies={activeSpecies}
                activeLocation={activeLocation}
                setActiveLocation={setActiveLocation}
                observationsByLocation={observationsByLocation}
                familyByTaxonomicOrder={familyByTaxonomicOrder}
                setObservationImages={setObservationImages}
                onShowTimePeriodSelector={onShowTimePeriodSelector}
            />
        </>
    );
}
